import type { Blueprint } from '@builder/base/blueprints/Blueprint';
import type { IdentityCallback } from '@builder/base/types/Identity';
import type { FormBuilderContract } from '@builder/form';
import { FormBuilder } from '@builder/form';
import { FormBlueprintFactory } from '@builder/form/services/FormBlueprintFactory';
import type { Entry } from '@builder/form/entries/Entry';
import { types } from './definitions';

export class FluentFormBuilder
{
    private builder: FormBuilder;
    private options: {
        blueprint?: () => Blueprint;
        entry?: () => Entry;
        blueprintId?: IdentityCallback;
        entryId?: IdentityCallback;
    };

    public constructor(builder: FormBuilder)
    {
        this.builder = builder;
        this.options = {};
    }

    public static setup(design: boolean = false, internal: boolean = false): FluentFormBuilder
    {
        const blueprintFactory = new FormBlueprintFactory(types);
        const formBuilder = new FormBuilder(blueprintFactory);

        formBuilder.design = design;
        formBuilder.internal = internal;

        return new FluentFormBuilder(formBuilder);
    }

    public blueprint(blueprint: () => Blueprint, blueprintId: IdentityCallback = () => 0): FluentFormBuilder
    {
        this.options.blueprint = blueprint;
        this.options.blueprintId = blueprintId;

        return this;
    }

    public entry(entry: () => Entry, entryId: IdentityCallback = () => 0): FluentFormBuilder
    {
        this.options.entry = entry;
        this.options.entryId = entryId;

        return this;
    }

    public make(): FormBuilderContract
    {
        this.builder.setBlueprint(this.options.blueprint);
        this.builder.setBlueprintIdentity(this.options.blueprintId);
        this.builder.setEntry(this.options.entry);
        this.builder.setEntryIdentity(this.options.entryId);
        this.builder.update();

        return this.builder;
    }
}
